import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 300px;
    padding: 2rem;
    text-align: center;
    background-color: var(--standard-color, #fff);
`;

const Panel = styled.div`
    background: var(--surface-color);
    border: 1px solid var(--border-color);
    border-left: 4px solid var(--accent-color);
    border-radius: 12px;
    box-shadow: 0 18px 45px rgba(78, 58, 10, 0.14);
    max-width: 560px;
    padding: 1.5rem;
`;

const Heading = styled.h2`
    margin-bottom: 0.75rem;
    font-size: 1.4rem;
`;

const Message = styled.p`
    color: var(--muted-text-color);
    margin-bottom: 0;
    max-width: 500px;
`;

const ServerUnavailable = () => (
    <Overlay>
        <Panel>
            <Heading>Currently Undergoing Maintenance</Heading>
            <Message>
                The solar calculator is currently undergoing maintenance.
                Please check back shortly.
            </Message>
        </Panel>
    </Overlay>
);

export default ServerUnavailable;
